import { Select } from 'components/ui/Select';
import { CommentCodeSelect } from 'containers/CommentDetails/lib/CommentCodeSelect';
import * as _ from 'lodash';
import * as React from 'react';
import { Col, Nav, NavItem, NavLink, Row } from 'reactstrap';
import { LazyTabPane } from '../../components/LazyTabPane';
import { SurveyReviewGrid } from './lib/SurveyReviewGrid';
import { GetActionReasons, GetSurveyDetails, IActionAlert, IProcessComment, SaveCurrentState } from './lib/utils';

interface IProcessCommentsState {
  currentIndex?: number
  totalObjects?: number
  actionAlertReasons?: IActionAlert[]
  surveys?: IProcessComment[]
  currentSurvey?: IProcessComment
  currentActionReason?: number
  isProcessing?: boolean
}

export class ProcessCommentsContainer extends React.Component<{}, IProcessCommentsState> {
  state: IProcessCommentsState = {
    currentIndex: 0,
    totalObjects: 0,
    actionAlertReasons: [],
    surveys: [],
    currentSurvey: null,
    currentActionReason: 0,
    isProcessing: true,
  }

  constructor(props) {
    super(props)
  }

  componentWillMount() {
    const surveysStr = window.localStorage.getItem(SurveyReviewGrid.SurveyReviewGridProcessWorkKey)

    let surveys
    try {
      surveys = JSON.parse(surveysStr)
    } catch (err) {
      console.log(err)
    }

    this.setState({ isProcessing: true })

    GetSurveyDetails(surveys).then((details) => {
      const currentSurvey = (details.length > 0 ? details[0] : null)
      this.setState({ totalObjects: details.length, currentIndex: 0, surveys: details, currentSurvey, currentActionReason: currentSurvey.actionReason, isProcessing: false })
    })

    GetActionReasons().then((reasons) => {
      this.setState({ actionAlertReasons: reasons })
    })
  }

  loadCurrentSurvey() {
    const { currentIndex, surveys } = this.state

  }

  updateOpenEndedText(event) {
    const { currentSurvey } = this.state
    const qid = event.target.id

    currentSurvey.surveyJson[qid] = event.target.value.replace((/  |\r\n|\n|\r/gm), ' ');

    this.setState({ currentSurvey })
  }

  updateCommentCodes(qid, codes) {
    const { currentSurvey } = this.state

    const indexFound = currentSurvey.openEndedQuestions.findIndex((element) => {
      return element.qid === qid
    })

    currentSurvey.openEndedQuestions[indexFound].codes = codes
    currentSurvey.openEndedQuestions[indexFound].comment = currentSurvey.surveyJson[qid]
    this.setState({ currentSurvey })
  }

  nextSurvey() {
    const { currentIndex, totalObjects, currentSurvey, surveys, currentActionReason } = this.state

    currentSurvey.actionReason = currentActionReason

    //NOTE: Save current progress
    surveys[currentIndex] = currentSurvey

    const nSurvey = surveys[currentIndex + 1]
    const nextActionReason = nSurvey && nSurvey.actionReason ? nSurvey.actionReason : 0

    //NOTE: Increment current index and update current survey
    this.setState({ currentIndex: currentIndex + 1, currentSurvey: nSurvey, surveys, currentActionReason: nextActionReason })
  }

  previousSurvey() {
    const { currentIndex, totalObjects, currentSurvey, surveys, currentActionReason } = this.state

    currentSurvey.actionReason = currentActionReason

    //NOTE: Save current progress
    surveys[currentIndex] = currentSurvey

    const prevSurvey = surveys[currentIndex - 1]
    const prevActionReason = prevSurvey && prevSurvey.actionReason ? prevSurvey.actionReason : 0

    //NOTE: Decrement current index and update current survey
    this.setState({ currentIndex: currentIndex - 1, currentSurvey: prevSurvey, surveys, currentActionReason: prevActionReason })
  }

  updateWowItem(event) {
    const { currentSurvey } = this.state

    currentSurvey.isWoW = event.target.checked

    this.setState({ currentSurvey })
  }

  updateActionItem(event) {
    const { currentSurvey } = this.state

    currentSurvey.isActionItem = event.target.checked

    this.setState({ currentSurvey })
  }

  updateDoNotCall(event) {
    const { currentSurvey } = this.state

    currentSurvey.doNotCall = event.target.checked

    this.setState({ currentSurvey })
  }

  saveCurrentState() {
    const { currentIndex, totalObjects, currentSurvey, surveys, currentActionReason } = this.state
    currentSurvey.actionReason = currentActionReason

    //NOTE: Save current progress
    surveys[currentIndex] = currentSurvey
    this.setState({ isProcessing: true })

    SaveCurrentState(surveys).then(() => {
      window.location.href = 'survey_review'
    })
  }

  render() {
    const { currentIndex, totalObjects, actionAlertReasons, currentSurvey, currentActionReason } = this.state
    return (
      <section className="blacklight page-container">
        <section className="containerv2">
          <h2>Process Comments {this.state.isProcessing ? <i key="Processing" className="fas fa-cog fa-spin fa-fw" /> : null}</h2>
        </section>
        {currentSurvey &&
          <section className="containerv2 card" style={{ backgroundColor: '#e1e1e1' }}>
            <div className="card" style={{ fontSize: '1.7vw', padding: '10px', marginTop: '10px' }}>
              <span className="text-center">{currentIndex + 1} of {totalObjects}<span className="float-right">
                <a className="btn btn-primary" onClick={this.saveCurrentState.bind(this)} > Back</a>&nbsp;
                <button className="btn btn-primary" disabled={currentIndex + 1 === 1} onClick={this.previousSurvey.bind(this)}>Previous</button>&nbsp;
                <button className="btn btn-primary" disabled={currentIndex + 1 === totalObjects} onClick={this.nextSurvey.bind(this)}>Next</button>&nbsp;
                <button className="btn btn-secondary" onClick={this.saveCurrentState.bind(this)}>Done</button>
              </span></span>
            </div>
            <div className="card" style={{ padding: '20px' }}>
              <div className="row">
                <div className="col-sm-12 col-md-3">
                  <b>Survey:</b> {currentSurvey ? currentSurvey.survey : ''}
                </div>
                <div className="col-sm-12 col-md-3">
                  <b>Branch:</b> {currentSurvey ? currentSurvey.branchName : ''}
                </div>
                <div className="col-sm-12 col-md-3">
                  <b>External Data Reference:</b> {currentSurvey ? currentSurvey.externalDataReference : ''}
                </div>
                <div className="col-sm-12 col-md-3">
                  <b>{currentSurvey ? currentSurvey.defaultQidQuestionText + ':' : ''}</b> {currentSurvey && currentSurvey.surveyJson && currentSurvey.surveyJson.hasOwnProperty(currentSurvey.defaultQid) ? currentSurvey.surveyJson[currentSurvey.defaultQid] : ''}
                </div>
              </div>
            </div>
            <div className="card" style={{ padding: '20px' }}>
              <div className="row">
                <div className="col-sm-12 col-md-3">
                  <div className="form-check">
                    <input type="checkbox" className="form-check-input" id="actionItemCheckbox" onChange={this.updateActionItem.bind(this)} checked={currentSurvey && currentSurvey.isActionItem} />
                    <label className="form-check-label" htmlFor="actionItemCheckbox">Action Item</label>
                  </div>
                </div>
                <div className="col-sm-12 col-md-3">
                  <Select
                    label="Action Reason"
                    options={actionAlertReasons}
                    loading={actionAlertReasons.length === 0}
                    valueKey="id"
                    labelKey="reason"
                    value={currentActionReason}
                    onChange={(newValue) => this.setState({ currentActionReason: newValue })} />
                </div>
                <div className="col-sm-12 col-md-3">
                  <div className="form-check">
                    <input type="checkbox" className="form-check-input" id="doNotCallCheckbox" onChange={this.updateDoNotCall.bind(this)} checked={currentSurvey && currentSurvey.doNotCall} />
                    <label className="form-check-label" htmlFor="doNotCallCheckbox">Do Not Call</label>
                  </div>
                </div>
                <div className="col-sm-12 col-md-3">
                  <div className="form-check">
                    <input type="checkbox" className="form-check-input" id="wowItemCheckbox" onChange={this.updateWowItem.bind(this)} checked={currentSurvey && currentSurvey.isWoW} />
                    <label className="form-check-label" htmlFor="wowItemCheckbox">WOW Item</label>
                  </div>
                </div>
              </div>
            </div>
            <div className="card" style={{ padding: '20px' }}>
              {currentSurvey.openEndedQuestions &&
                currentSurvey.openEndedQuestions.map((openEndedQuestion) => {
                  const codes = openEndedQuestion.codes ? openEndedQuestion.codes : []
                  return (
                    <div className="row" key={currentSurvey.externalDataReference + openEndedQuestion.qid}>
                      <div className="col-sm-12 col-md-9">
                        <div className="form-group">
                          <label htmlFor="exampleFormControlTextarea1">{openEndedQuestion.label}</label>
                          <textarea className="form-control" id={openEndedQuestion.qid} onChange={this.updateOpenEndedText.bind(this)} rows={3} value={currentSurvey.surveyJson.hasOwnProperty(openEndedQuestion.qid) ? currentSurvey.surveyJson[openEndedQuestion.qid] : ''}></textarea>
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-3">
                        <section style={{ paddingTop: '5px' }}>
                          Codes:
                          <CommentCodeSelect
                            values={codes}
                            onChange={(newCodes) => this.updateCommentCodes(openEndedQuestion.qid, newCodes)}
                          />
                        </section>
                      </div>
                    </div>
                  )
                })
              }
            </div>
          </section>
        }
      </section>
    )
  }
}